import React from 'react';
import { Users, ChevronRight, Home } from 'lucide-react';

const PropertyTable = ({ properties, onPropertyClick }) => {
  if (!properties || properties.length === 0) {
    return (
      <div className="bg-white border border-notion-border rounded-lg p-8 text-center shadow-card">
        <Home className="w-10 h-10 text-stone-300 mx-auto mb-3" />
        <h3 className="text-sm font-medium text-stone-600 mb-1">No properties yet</h3>
        <p className="text-xs text-stone-400">Click "Add Property" to create your first listing</p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-notion-border rounded-lg overflow-hidden shadow-card">
      <table className="w-full text-left">
        <thead className="bg-stone-50 border-b border-notion-border">
          <tr>
            <th className="py-3 px-4 text-[10px] font-semibold text-stone-400 uppercase w-16">Image</th>
            <th className="py-3 px-4 text-[10px] font-semibold text-stone-400 uppercase">Address</th>
            <th className="py-3 px-4 text-[10px] font-semibold text-stone-400 uppercase">Price</th>
            <th className="py-3 px-4 text-[10px] font-semibold text-stone-400 uppercase">Leads</th>
            <th className="py-3 px-4 text-[10px] font-semibold text-stone-400 uppercase text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-notion-border text-xs">
          {properties.map((property) => (
            <tr key={property.id} className="group hover:bg-notion-sidebar transition-colors cursor-pointer" onClick={() => onPropertyClick(property.id)}>
              <td className="p-3"><div className="w-10 h-10 bg-stone-200 rounded bg-cover bg-center" style={{ backgroundImage: `url('${property.image}')` }}></div></td>
              <td className="p-3 font-medium text-stone-700">{property.address}</td>
              <td className="p-3 text-stone-600">{property.price}</td>
              <td className="p-3"><span className="flex items-center gap-1"><Users className="w-3 h-3 text-stone-400" /> {property.leads}</span></td>
              <td className="p-3 text-right">
                <button className="text-stone-400 hover:text-stone-700 p-1 hover:bg-stone-200 rounded"><ChevronRight className="w-4 h-4" /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PropertyTable;
